import { ApiService } from './ApiService';
import { AnimalFeedHistory } from '../models/feed-registration';

/**
 * Reads one animal's share of the feed its pens received.
 *
 * The endpoint is unpaged on purpose: the split is computed on read from the animal's location
 * history, so a page boundary would have to be applied after the allocation rather than in the
 * query, and an animal's whole history is small enough not to need one.
 */
export class AnimalFeedHistoryService extends ApiService {
  getFeedHistory = async (animalId: string): Promise<AnimalFeedHistory> => {
    const result = await this.api.animals.animalsGetAnimalFeedHistory({ id: animalId });

    return result.data;
  };
}

export default AnimalFeedHistoryService;
